import { createSelector } from 'reselect';

const substate = (state) => state.payment;

export const selectPaymentTransferResultErrors = () =>
    createSelector(substate, (contextState) => contextState.paymentTransferResultErrors);
